<script lang="ts">
	import { Section, type SectionTheme } from "#lib/web-ui/primitives/index.js";

	interface Props {
		lead: string;
		cities: string[];
		theme?: SectionTheme;
		id?: string;
		class?: string;
	}

	let { lead, cities, theme = "dark", id, class: className }: Props = $props();
</script>

<Section {theme} {id} class={className} data-testid="associate-city-chips">
	<p class="text-muted-foreground text-sm">{lead}</p>
	<ul class="mt-4 flex flex-wrap gap-2">
		{#each cities as city (city)}
			<li
				class="border-border text-primary rounded-full border px-4 py-1 text-sm font-semibold"
			>
				{city}
			</li>
		{/each}
	</ul>
</Section>
